import { CollectionRequest } from '@modules/layout/requests';

import type { SummaryLapsStudentsTableFiltersQuery } from '@modules/summary-results/hooks';
import type { SummaryLapsStudentCollectionFilter } from '@modules/types/graphql';

class SummaryLapsStudentCollectionRequest extends CollectionRequest {
    filter?: SummaryLapsStudentCollectionFilter;

    constructor(values: SummaryLapsStudentsTableFiltersQuery['filters']) {
        super(values);

        this.filter = {};

        if (values.fullName) {
            this.filter = {
                ...this.filter,
                fullName: values.fullName,
            };
        }

        if (typeof values.isOut !== 'undefined') {
            this.filter = {
                ...this.filter,
                isOut: values.isOut,
            };
        }

        if (typeof values.isCommercial !== 'undefined') {
            this.filter = {
                ...this.filter,
                isCommercial: values.isCommercial,
            };
        }

        if (typeof values.isCompleted !== 'undefined') {
            this.filter = {
                ...this.filter,
                isCompleted: values.isCompleted,
            };
        }

        if (values.lapIds) {
            this.filter = {
                ...this.filter,

                summaryResults: {
                    ...this.filter.summaryResults,
                    lapIds: values.lapIds,
                },
            };
        }

        if (values.from) {
            this.filter = {
                ...this.filter,

                summaryResults: {
                    ...this.filter.summaryResults,
                    from: values.from,
                },
            };
        }

        if (values.to) {
            this.filter = {
                ...this.filter,

                summaryResults: {
                    ...this.filter.summaryResults,
                    to: values.to,
                },
            };
        }

        if (values.locationId) {
            this.filter = {
                ...this.filter,

                summaryResults: {
                    ...this.filter.summaryResults,
                    locationId: values.locationId,
                },
            };
        }

        if (values.regionId) {
            this.filter = {
                ...this.filter,

                summaryResults: {
                    ...this.filter.summaryResults,
                    regionId: values.regionId,
                },
            };
        }
    }
}

export { SummaryLapsStudentCollectionRequest };
